import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommonModule } from '@common/common.module';
import { CanDeactivateVesselNotification } from '@common/guards/vessel-notification.deactivate';
import { CanDeactivateView } from '@common/guards/view.deactivate';
import { ViewMode } from '@common/models/view-mode';
import { EditorModule } from '@progress/kendo-angular-editor';
import { ChangeAgencyModalComponent } from './components/change-agency-modal/change-agency-modal.component';
import { ConfirmSendVesselNotificationModalComponent } from './components/confirm-send-vessel-notification-modal/confirm-send-vessel-notification-modal.component';
import { CreateDepartureModalComponent } from './components/create-departure-modal/create-departure-modal.component';
import { CreateGeneralRemarkModalComponent } from './components/create-general-remark-modal/create-general-remark-modal.component';
import { UpdateVesselNotificationModalComponent } from './components/update-vessel-notification-modal/update-vessel-notification-modal.component';
import { UploadVesselNotificationModalComponent } from './components/upload-vessel-notification-modal/upload-vessel-notification-modal.component';
import { VesselNotificationAccompaniedGridComponent } from './components/vessel-notification-accompanied-grid/vessel-notification-accompanied-grid.component';
import { VesselNotificationAccompaniedComponent } from './components/vessel-notification-accompanied/vessel-notification-accompanied.component';
import { VesselNotificationAttachmentGridComponent } from './components/vessel-notification-attachment-grid/vessel-notification-attachment-grid.component';
import { VesselNotificationAttachmentComponent } from './components/vessel-notification-attachment/vessel-notification-attachment.component';
import { VesselNotificationBunkerComponent } from './components/vessel-notification-bunker/vessel-notification-bunker.component';
import { VesselNotificationCargoComponent } from './components/vessel-notification-cargo/vessel-notification-cargo.component';
import { VesselNotificationDangerousGoodsComponent } from './components/vessel-notification-dangerous-goods/vessel-notification-dangerous-goods.component';
import { VesselNotificationDefectsModalComponent } from './components/vessel-notification-defects-modal/vessel-notification-defects-modal.component';
import { VesselNotificationDetailsComponent } from './components/vessel-notification-details/vessel-notification-details.component';
import { VesselNotificationGeneralRemarksComponent } from './components/vessel-notification-general-remarks/vessel-notification-general-remarks.component';
import { VesselNotificationGridComponent } from './components/vessel-notification-grid/vessel-notification-grid.component';
import { VesselNotificationHealthComponent } from './components/vessel-notification-health/vessel-notification-health.component';
import { VesselNotificationItineraryComponent } from './components/vessel-notification-itinerary/vessel-notification-itinerary.component';
import { VesselNotificationListComponent } from './components/vessel-notification-list/vessel-notification-list.component';
import { VesselNotificationLogComponent } from './components/vessel-notification-log/vessel-notification-log.component';
import { VesselNotificationManifestComponent } from './components/vessel-notification-manifest/vessel-notification-manifest.component';
import { VesselNotificationPassengerComponent } from './components/vessel-notification-passenger/vessel-notification-passenger.component';
import { VesselNotificationPermissionComponent } from './components/vessel-notification-permission/vessel-notification-permission.component';
import { VesselNotificationPrintComponent } from './components/vessel-notification-print/vessel-notification-print.component';
import { VesselNotificationSecurityComponent } from './components/vessel-notification-security/vessel-notification-security.component';
import { VesselNotificationStoreProductComponent } from './components/vessel-notification-store-product/vessel-notification-store-product.component';
import { VesselNotificationViewContentComponent } from './components/vessel-notification-view-content/vessel-notification-view-content.component';
import { VesselNotificationViewComponent } from './components/vessel-notification-view/vessel-notification-view.component';
import { VesselNotificationVoyageComponent } from './components/vessel-notification-voyage/vessel-notification-voyage.component';
import { VesselNotificationWasteDepartureComponent } from './components/vessel-notification-waste-departure/vessel-notification-waste-departure.component';
import { VesselNotificationWasteComponent } from './components/vessel-notification-waste/vessel-notification-waste.component';
import { VesselNotificationWorkerComponent } from './components/vessel-notification-worker/vessel-notification-worker.component';
import { VesselNotificationWasteGridComponent } from './components/vessel-notification-waste-grid/vessel-notification-waste-grid.component';

export const VESSEL_NOTIFICATION_ROUTES: Routes = [
    {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full'
    },
    {
        path: 'list',
        component: VesselNotificationListComponent
    },
    {
        path: 'create',
        component: VesselNotificationViewComponent,
        data: {
            mode: ViewMode.create
        },
        canDeactivate: [CanDeactivateVesselNotification]
    },
    {
        path: 'edit/:id',
        component: VesselNotificationViewComponent,
        data: {
            mode: ViewMode.edit
        },
        canDeactivate: [CanDeactivateView]
    },
    {
        path: 'view/:id',
        component: VesselNotificationViewComponent,
        data: {
            mode: ViewMode.view
        }
    },
    {
        path: '**',
        redirectTo: 'list'
    }
];

@NgModule({
    declarations: [
        VesselNotificationViewComponent,
        VesselNotificationBunkerComponent,
        VesselNotificationWasteComponent,
        VesselNotificationWasteGridComponent,
        VesselNotificationWasteDepartureComponent,
        VesselNotificationVoyageComponent,
        VesselNotificationDangerousGoodsComponent,
        VesselNotificationStoreProductComponent,
        VesselNotificationWorkerComponent,
        VesselNotificationPassengerComponent,
        VesselNotificationSecurityComponent,
        VesselNotificationHealthComponent,
        VesselNotificationItineraryComponent,
        VesselNotificationListComponent,
        VesselNotificationCargoComponent,
        VesselNotificationLogComponent,
        VesselNotificationAttachmentComponent,
        VesselNotificationPermissionComponent,
        VesselNotificationViewContentComponent,
        VesselNotificationAttachmentGridComponent,
        VesselNotificationPrintComponent,
        VesselNotificationDetailsComponent,
        UpdateVesselNotificationModalComponent,
        UploadVesselNotificationModalComponent,
        CreateDepartureModalComponent,
        ConfirmSendVesselNotificationModalComponent,
        VesselNotificationDefectsModalComponent,
        VesselNotificationGridComponent,
        VesselNotificationAccompaniedComponent,
        VesselNotificationAccompaniedGridComponent,
        ChangeAgencyModalComponent,
        VesselNotificationGeneralRemarksComponent,
        CreateGeneralRemarkModalComponent,
        VesselNotificationManifestComponent
    ],
    exports: [
        VesselNotificationViewComponent,
        VesselNotificationBunkerComponent,
        VesselNotificationWasteComponent,
        VesselNotificationWasteGridComponent,
        VesselNotificationWasteDepartureComponent,
        VesselNotificationVoyageComponent,
        VesselNotificationDangerousGoodsComponent,
        VesselNotificationStoreProductComponent,
        VesselNotificationWorkerComponent,
        VesselNotificationPassengerComponent,
        VesselNotificationSecurityComponent,
        VesselNotificationHealthComponent,
        VesselNotificationItineraryComponent,
        VesselNotificationListComponent,
        VesselNotificationCargoComponent,
        VesselNotificationLogComponent,
        VesselNotificationAttachmentComponent,
        VesselNotificationPermissionComponent,
        VesselNotificationViewContentComponent,
        VesselNotificationAttachmentGridComponent,
        VesselNotificationPrintComponent,
        VesselNotificationDetailsComponent,
        UpdateVesselNotificationModalComponent,
        UploadVesselNotificationModalComponent,
        CreateDepartureModalComponent,
        ConfirmSendVesselNotificationModalComponent,
        VesselNotificationDefectsModalComponent,
        VesselNotificationGridComponent,
        VesselNotificationAccompaniedComponent,
        VesselNotificationAccompaniedGridComponent,
        VesselNotificationManifestComponent
    ],
    imports: [CommonModule, EditorModule],
    providers: [CanDeactivateView, CanDeactivateVesselNotification]
})
export class VesselNotificationComponentModule { }


@NgModule({
    imports: [CommonModule, VesselNotificationComponentModule, RouterModule.forChild(VESSEL_NOTIFICATION_ROUTES)]
})
export class VesselNotificationModule { }
